import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'phone',
  pure: false,
  standalone: true,
})
export class PhonePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    const digits = value.replace(/\D/g, '');

    if (value.trim().startsWith('+') && !digits.startsWith('55')) {
      return value;
    }

    const local =
      digits.length > 11 && digits.startsWith('55') ? digits.slice(2) : digits;

    if (local.length === 10) {
      return local.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    }

    if (local.length === 11) {
      return local.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    }

    return value;
  }
}
